import { MutationPayload } from "vuex";
import { capitalize } from "lodash";
import { SnapshotLabelActionAndSubject } from "@/types/snapshot";

export function generateSnapshotLabel(
  actionAndSubject: SnapshotLabelActionAndSubject,
  otherParts: string[] = []
): string {
  return joinSnapshotLabelParts([
    `${actionAndSubject.action} ${actionAndSubject.subject}`,
    ...otherParts
  ]);
}

export function joinSnapshotLabelParts(labels: string[]): string {
  return labels.join(" → ");
}

/**
 * Implicit fallback for snapshot labels – infers snapshot label from mutation name when no explicit label is specified.
 */
export function getSnapshotTitleFromMutation(mutation: MutationPayload) {
  // This is the least preferred option, so we would like to track its
  // occurences in order to know where to add human-readable explicit labels
  console.warn(
    "Snapshot title is inferred from mutation payload automatically. In general, you don't want this to happen – make sure mutation is wrapped with a transaction with a meaningful snapshot title.",
    mutation
  );

  // Mutation type can be in the form:
  // - document/addMultipleNodesMutation
  const parts = mutation.type.split("/");
  return capitalize(
    parts[1]
      .split(/(?=[A-Z])/)
      .filter(p => "Mutation" !== p)
      .join(" ")
      .toLowerCase()
  );
}
